import type { InputProps } from '.';

const sensitiveFields = [
  'email',
  'name',
  'phone',
  'lastWrittenCoverLetter',
  'questionnaire',
  'text',
];

const debugOverride = ['__typename', 'id'];

export const scrubAllFields = (parentKey: string, obj: InputProps) => {
  if (debugOverride.some((x) => x.toLowerCase() === parentKey.toLowerCase())) {
    return obj;
  }

  if (typeof obj !== 'object') {
    return '*****';
  }

  return Object.entries(obj).reduce((acc: InputProps, [key, value]) => {
    if (
      debugOverride.some((x) => x.toLowerCase() === key.toLowerCase()) ||
      value === null
    ) {
      acc[key] = value;
    } else if (typeof value === 'object') {
      acc[key] = scrubAllFields(key, value);
    } else {
      acc[key] = '*****';
    }

    return acc;
  }, {});
};

export const scrubSensitiveData = (obj: InputProps) =>
  Object.entries(obj).reduce((acc: InputProps, [key, value]) => {
    if (
      value === null ||
      debugOverride.some((x) => key.toLowerCase() === x.toLowerCase())
    ) {
      acc[key] = value;
    } else if (
      sensitiveFields.some((x) => key.toLowerCase().includes(x.toLowerCase()))
    ) {
      acc[key] = scrubAllFields(key, value);
    } else if (typeof value === 'object') {
      acc[key] = scrubSensitiveData(value);
    } else {
      acc[key] = value;
    }

    return acc;
  }, {});
